export enum GlyphIconName {
	glass = '1-glass',
	'magic-wand' = '10-magic-wand',
	'vector-path-edit' = '100-vector-path-edit',
	'memory-card-eject' = '1000-memory-card-eject',
	celeriac = '1001-celeriac',
	celery = '1002-celery',
	lupin = '1003-lupin',
	mustard = '1004-mustard',
	sesame = '1005-sesame',
	peanuts = '1006-peanuts',
	'invoice-plus' = '1007-invoice-plus',
	'invoice-minus' = '1008-invoice-minus',
	'invoice-alert' = '1009-invoice-alert',
	text = '101-text',
	'invoice-check' = '1010-invoice-check',
	molluscs = '1011-molluscs',
	'percent-sign' = '1012-percent-sign',
	'mobile-phone-scan' = '1013-mobile-phone-scan',
	'mobile-phone-nfc' = '1014-mobile-phone-nfc',
	'mobile-phone-charger' = '1015-mobile-phone-charger',
	'iris-scan' = '1016-iris-scan',
	'face-scan' = '1017-face-scan',
	'voice-scan' = '1018-voice-scan',
	'user-voice' = '1019-user-voice',
	italic = '102-italic',
	'head-voice' = '1020-head-voice',
	shadows = '1021-shadows',
	highlights = '1022-highlights',
	vignetting = '1023-vignetting',
	'correction-skewed' = '1024-correction-skewed',
	'correction-skewed-alt' = '1025-correction-skewed-alt',
	'correction-tilted' = '1026-correction-tilted',
	'correction-auto' = '1027-correction-auto',
	'safe-open' = '1028-safe-open',
	safe = '1029-safe',
	bold = '103-bold',
	'safe-digital' = '1030-safe-digital',
	underline = '104-underline',
	strikethrough = '105-strikethrough',
	'text-height' = '106-text-height',
	'text-width' = '107-text-width',
	'text-resize' = '108-text-resize',
	'indent-left' = '109-indent-left',
	envelope = '11-envelope',
	'indent-right' = '110-indent-right',
	'paragraph-left' = '111-paragraph-left',
	'paragraph-center' = '112-paragraph-center',
	'paragraph-right' = '113-paragraph-right',
	'paragraph-justify' = '114-paragraph-justify',
	list = '115-list',
	'text-smaller' = '116-text-smaller',
	'text-bigger' = '117-text-bigger',
	'terminal-isolated' = '118-terminal-isolated',
	code = '119-code',
	camera = '12-camera',
	table = '120-table',
	'envelope-full' = '121-envelope-full',
	'envelope-empty' = '122-envelope-empty',
	'envelope-down' = '123-envelope-down',
	'envelope-up' = '124-envelope-up',
	'envelope-plus' = '125-envelope-plus',
	'envelope-minus' = '126-envelope-minus',
	'envelope-no' = '127-envelope-no',
	'envelope-flag' = '128-envelope-flag',
	'envelope-lock' = '129-envelope-lock',
	heart = '13-heart',
	'envelope-star' = '130-envelope-star',
	inbox = '131-inbox',
	'inbox-plus' = '132-inbox-plus',
	'inbox-minus' = '133-inbox-minus',
	'inbox-lock' = '134-inbox-lock',
	'inbox-down' = '135-inbox-down',
	'inbox-up' = '136-inbox-up',
	cogwheel = '137-cogwheel',
	cogwheels = '138-cogwheels',
	curves = '139-curves',
	'beach-umbrella' = '14-beach-umbrella',
	adjust = '140-adjust',
	database = '141-database',
	'database-plus' = '142-database-plus',
	'database-minus' = '143-database-minus',
	'database-search' = '144-database-search',
	'folder-open' = '145-folder-open',
	'folder-plus' = '146-folder-plus',
	'folder-minus' = '147-folder-minus',
	'folder-refresh' = '148-folder-refresh',
	'folder-check' = '149-folder-check',
	train = '15-train',
	'folder-star' = '150-folder-star',
	'square-edit' = '151-square-edit',
	'square-new-window' = '152-square-new-window',
	'square-checkbox' = '153-square-checkbox',
	'square-empty' = '154-square-empty',
	'square-selected' = '155-square-selected',
	'square-indeterminate' = '156-square-indeterminate',
	thumbnails = '157-thumbnails',
	'thumbnails-small' = '158-thumbnails-small',
	'thumbnails-list' = '159-thumbnails-list',
	print = '16-print',
	playlist = '160-playlist',
	'computer-all-in-one' = '161-computer-all-in-one',
	'computer-pc-tower' = '162-computer-pc-tower',
	computer = '163-computer',
	notebook = '164-notebook',
	tablet = '165-tablet',
	'mobile-phone' = '166-mobile-phone',
	'mobile-phone-off' = '167-mobile-phone-off',
	'mobile-phone-vibrations' = '168-mobile-phone-vibrations',
	'mobile-phone-shaking' = '169-mobile-phone-shaking',
	bin = '17-bin',
	earphones = '170-earphones',
	'skip-to-previous' = '171-skip-to-previous',
	'skip-to-start' = '172-skip-to-start',
	rewind = '173-rewind',
	pause = '174-pause',
	play = '175-play',
	stop = '176-stop',
	forward = '177-forward',
	'skip-to-end' = '178-skip-to-end',
	'skip-to-next' = '179-skip-to-next',
	music = '18-music',
	eject = '180-eject',
	video = '181-video',
	'video-off' = '182-video-off',
	'volume-bluetooth' = '183-volume-bluetooth',
	'volume-off' = '184-volume-off',
	'volume-down' = '185-volume-down',
	'volume-up' = '186-volume-up',
	'volume-max' = '187-volume-max',
	cd = '188-cd',
	mc = '189-mc',
	'music-alt' = '19-music-alt',
	lp = '190-lp',
	'circle-empty-plus' = '191-circle-empty-plus',
	'circle-empty-minus' = '192-circle-empty-minus',
	'circle-empty-remove' = '193-circle-empty-remove',
	'circle-empty-check' = '194-circle-empty-check',
	'circle-empty-question' = '195-circle-empty-question',
	'circle-empty-info' = '196-circle-empty-info',
	'circle-empty-alert' = '197-circle-empty-alert',
	open = '198-open',
	save = '199-save',
	leaf = '2-leaf',
	'heart-empty' = '20-heart-empty',
	'save-as' = '200-save-as',
	cart = '201-cart',
	'cart-in' = '202-cart-in',
	'cart-out' = '203-cart-out',
	'cart-checkout' = '204-cart-checkout',
	'cart-check' = '205-cart-check',
	'circle-empty-play' = '206-circle-empty-play',
	'circle-empty-down' = '207-circle-empty-down',
	'circle-empty-up' = '208-circle-empty-up',
	'circle-empty-left' = '209-circle-empty-left',
	home = '21-home',
	'circle-empty-right' = '210-circle-empty-right',
	'arrow-down' = '211-arrow-down',
	'arrow-up' = '212-arrow-up',
	'arrow-left' = '213-arrow-left',
	'arrow-right' = '214-arrow-right',
	'fullscreen-off' = '215-fullscreen-off',
	fullscreen = '216-fullscreen',
	lock = '217-lock',
	'lock-open' = '218-lock-open',
	coins = '219-coins',
	snowflake = '22-snowflake',
	banknotes = '220-banknotes',
	'chevron-down' = '221-chevron-down',
	'chevron-up' = '222-chevron-up',
	'chevron-left' = '223-chevron-left',
	'chevron-right' = '224-chevron-right',
	bitcoin = '225-bitcoin',
	euro = '226-euro',
	dollar = '227-dollar',
	pound = '228-pound',
	yen = '229-yen',
	fire = '23-fire',
	ruble = '230-ruble',
	moon = '231-moon',
	sun = '232-sun',
	lasso = '233-lasso',
	calculator = '234-calculator',
	'chat-conversation' = '235-chat-conversation',
	'chat-conversation-off' = '236-chat-conversation-off',
	'chat-conversation-lock' = '237-chat-conversation-lock',
	'chat-message' = '238-chat-message',
	'chat-message-lock' = '239-chat-message-lock',
	magnet = '24-magnet',
	'chat-message-check' = '240-chat-message-check',
	brush = '241-brush',
	marker = '242-marker',
	pen = '243-pen',
	spray = '244-spray',
	fill = '245-fill',
	clean = '246-clean',
	'drop-off' = '247-drop-off',
	palette = '248-palette',
	diamond = '249-diamond',
	'user-parents' = '25-user-parents',
	eraser = '250-eraser',
	'diving-free' = '251-diving-free',
	'diving-scuba' = '252-diving-scuba',
	boat = '253-boat',
	'swimming-pool' = '254-swimming-pool',
	buoy = '255-buoy',
	'oxygen-bottles' = '256-oxygen-bottles',
	fins = '257-fins',
	anchor = '258-anchor',
	fishes = '259-fishes',
	binoculars = '26-binoculars',
	'fishes-bait' = '260-fishes-bait',
	direction = '261-direction',
	'direction-empty' = '262-direction-empty',
	'direction-full' = '263-direction-full',
	'flag-waving' = '264-flag-waving',
	flag = '265-flag',
	'flag-triangle' = '266-flag-triangle',
	comments = '267-comments',
	'comments-off' = '268-comments-off',
	'comments-lock' = '269-comments-lock',
	road = '27-road',
	cake = '270-cake',
	'set-wine' = '271-set-wine',
	'glass-wine' = '272-glass-wine',
	'coffee-mug' = '273-coffee-mug',
	drink = '274-drink',
	beer = '275-beer',
	'beer-alt' = '276-beer-alt',
	'fast-food' = '277-fast-food',
	cutlery = '278-cutlery',
	blender = '279-blender',
	search = '28-search',
	pizza = '280-pizza',
	'coffee-to-go' = '281-coffee-to-go',
	'tea-pot' = '282-tea-pot',
	'tea-mug' = '283-tea-mug',
	'coffee-beans' = '284-coffee-beans',
	'tea-leaves' = '285-tea-leaves',
	'french-press' = '286-french-press',
	pot = '287-pot',
	kettle = '288-kettle',
	grater = '289-grater',
	cars = '29-cars',
	'cooks-hat' = '290-cooks-hat',
	'square-empty-plus' = '291-square-empty-plus',
	'square-empty-minus' = '292-square-empty-minus',
	'square-empty-remove' = '293-square-empty-remove',
	'square-empty-check' = '294-square-empty-check',
	'square-empty-question' = '295-square-empty-question',
	'square-empty-info' = '296-square-empty-info',
	'square-empty-alert' = '297-square-empty-alert',
	'circle-empty' = '298-circle-empty',
	'circle-selected' = '299-circle-selected',
	dog = '3-dog',
	clipboard = '30-clipboard',
	'asian-food' = '300-asian-food',
	'square-upload' = '301-square-upload',
	'square-download' = '302-square-download',
	'verify-empty' = '303-verify-empty',
	'verify-check' = '304-verify-check',
	'no-symbol' = '305-no-symbol',
	'square-empty-play' = '306-square-empty-play',
	'square-empty-download' = '307-square-empty-download',
	'square-empty-upload' = '308-square-empty-upload',
	'square-empty-left' = '309-square-empty-left',
	pencil = '31-pencil',
	'square-empty-right' = '310-square-empty-right',
	spade = '311-spade',
	saw = '312-saw',
	'claw-hammer' = '313-claw-hammer',
	hammer = '314-hammer',
	screwdriver = '315-screwdriver',
	wrench = '316-wrench',
	ax = '317-ax',
	blacksmith = '318-blacksmith',
	'saw-blade' = '319-saw-blade',
	bus = '32-bus',
	certificate = '320-certificate',
	users = '321-users',
	'shield-check' = '322-shield-check',
	'shield-half' = '323-shield-half',
	'shield-empty-star' = '324-shield-empty-star',
	'shield-quarter' = '325-shield-quarter',
	'shield-star' = '326-shield-star',
	'contactless-lock' = '327-contactless-lock',
	contactless = '328-contactless',
	'credit-card' = '329-credit-card',
	'access-point' = '33-access-point',
	'credit-card-off' = '330-credit-card-off',
	'quad-bike' = '331-quad-bike',
	motorbike = '332-motorbike',
	squares = '333-squares',
	'brightness-up' = '334-brightness-up',
	'brightness-down' = '335-brightness-down',
	folder = '336-folder',
	'folder-cogwheel' = '337-folder-cogwheel',
	'folder-alert' = '338-folder-alert',
	'folder-lock' = '339-folder-lock',
	luggage = '34-luggage',
	'folder-no' = '340-folder-no',
	mic = '341-mic',
	'mic-off' = '342-mic-off',
	repeat = '343-repeat',
	'repeat-once' = '344-repeat-once',
	'electric-cord' = '345-electric-cord',
	'self-winding-cord' = '346-self-winding-cord',
	'id-badge' = '347-id-badge',
	'id-badge-vertical' = '348-id-badge-vertical',
	'id-binder' = '349-id-binder',
	'user-incognito' = '35-user-incognito',
	'lock-off' = '350-lock-off',
	link = '351-link',
	'link-remove' = '352-link-remove',
	bank = '353-bank',
	'scissors-cutting' = '354-scissors-cutting',
	mouse = '355-mouse',
	'mouse-wireless' = '356-mouse-wireless',
	keyboard = '357-keyboard',
	'keyboard-wireless' = '358-keyboard-wireless',
	'graphic-tablet' = '359-graphic-tablet',
	'user-female' = '36-user-female',
	'graphic-tablet-wireless' = '360-graphic-tablet-wireless',
	't-shirt' = '361-t-shirt',
	't-shirt-v' = '362-t-shirt-v',
	't-shirt-sleeves' = '363-t-shirt-sleeves',
	shirt = '364-shirt',
	tie = '365-tie',
	trousers = '366-trousers',
	dress = '367-dress',
	underwear = '368-underwear',
	fabric = '369-fabric',
	file = '37-file',
	leather = '370-leather',
	plus = '371-plus',
	minus = '372-minus',
	times = '373-times',
	division = '374-division',
	equals = '375-equals',
	hanger = '376-hanger',
	flower = '377-flower',
	plant = '378-plant',
	'tree-conifer' = '379-tree-conifer',
	picture = '38-picture',
	'tree-deciduous' = '380-tree-deciduous',
	bowling = '381-bowling',
	rugby = '382-rugby',
	'table-tennis' = '383-table-tennis',
	basketball = '384-basketball',
	volleyball = '385-volleyball',
	football = '386-football',
	baseball = '387-baseball',
	hockey = '388-hockey',
	golf = '389-golf',
	airplane = '39-airplane',
	'golf-green' = '390-golf-green',
	winners = '391-winners',
	'winners-stars' = '392-winners-stars',
	medal = '393-medal',
	dumbbell = '394-dumbbell',
	filter = '395-filter',
	'filter-plus' = '396-filter-plus',
	'filter-minus' = '397-filter-minus',
	'filter-cogwheel' = '398-filter-cogwheel',
	import = '399-import',
	user = '4-user',
	notes = '40-notes',
	export = '400-export',
	'hard-drive' = '401-hard-drive',
	'hard-drive-cogwheel' = '402-hard-drive-cogwheel',
	'hard-drive-lock' = '403-hard-drive-lock',
	'hard-drive-eject' = '404-hard-drive-eject',
	turtle = '405-turtle',
	rabbit = '406-rabbit',
	cat = '407-cat',
	sailboat = '408-sailboat',
	webcam = '409-webcam',
	stats = '41-stats',
	projector = '410-projector',
	'shopping-bag' = '411-shopping-bag',
	dice = '412-dice',
	'game-controller' = '413-game-controller',
	'game-controller-wireless' = '414-game-controller-wireless',
	'push-pin' = '415-push-pin',
	'id-badge-lanyard' = '416-id-badge-lanyard',
	globe = '417-globe',
	'world-west' = '418-world-west',
	'world-east' = '419-world-east',
	'stats-bars' = '42-stats-bars',
	vases = '420-vases',
	'book-play' = '421-book-play',
	'book-library' = '422-book-library',
	'briefcase-alt' = '423-briefcase-alt',
	blackboard = '424-blackboard',
	crown = '425-crown',
	'home-flag' = '426-home-flag',
	'square-triangle-down' = '427-square-triangle-down',
	'square-triangle-up' = '428-square-triangle-up',
	'square-triangle-left' = '429-square-triangle-left',
	'stats-circle' = '43-stats-circle',
	'square-triangle-right' = '430-square-triangle-right',
	'log-in' = '431-log-in',
	'log-out' = '432-log-out',
	reply = '433-reply',
	'reply-all' = '434-reply-all',
	'forward-email' = '435-forward-email',
	archive = '436-archive',
	'playlist-music' = '437-playlist-music',
	'playlist-video' = '438-playlist-video',
	'video-play-empty' = '439-video-play-empty',
	'user-group' = '44-user-group',
	'video-play' = '440-video-play',
	bell = '441-bell',
	'bell-off' = '442-bell-off',
	'bell-ringing' = '443-bell-ringing',
	sampler = '444-sampler',
	wallet = '445-wallet',
	'wallet-plus' = '446-wallet-plus',
	'wallet-minus' = '447-wallet-minus',
	'wallet-lock' = '448-wallet-lock',
	'wallet-cogwheel' = '449-wallet-cogwheel',
	key = '45-key',
	'wallet-check' = '450-wallet-check',
	'hand-like' = '451-hand-like',
	'hand-dislike' = '452-hand-dislike',
	'hand-pointing-right' = '453-hand-pointing-right',
	'hand-pointing-left' = '454-hand-pointing-left',
	'hand-pointing-up' = '455-hand-pointing-up',
	'hand-pointing-down' = '456-hand-pointing-down',
	'hand-open' = '457-hand-open',
	'hand-open-alt' = '458-hand-open-alt',
	'hand-ok' = '459-hand-ok',
	calendar = '46-calendar',
	briefcase = '460-briefcase',
	send = '461-send',
	footprints = '462-footprints',
	'construction-cone' = '463-construction-cone',
	'phone-old' = '464-phone-old',
	call = '465-call',
	fax = '466-fax',
	shredder = '467-shredder',
	'multifunction-printer' = '468-multifunction-printer',
	scanner = '469-scanner',
	router = '47-router',
	'security-camera' = '470-security-camera',
	sort = '471-sort',
	'sort-alphabetically' = '472-sort-alphabetically',
	'sort-alphabetically-alt' = '473-sort-alphabetically-alt',
	'sort-numerically' = '474-sort-numerically',
	'sort-numerically-alt' = '475-sort-numerically-alt',
	'sort-attributes' = '476-sort-attributes',
	'sort-attributes-alt' = '477-sort-attributes-alt',
	switch = '478-switch',
	'user-scam' = '479-user-scam',
	'video-camera' = '48-video-camera',
	'user-scam-alt' = '480-user-scam-alt',
	'shop-window' = '481-shop-window',
	'shop-door' = '482-shop-door',
	kiosk = '483-kiosk',
	'kiosk-wheels' = '484-kiosk-wheels',
	'kiosk-immobile' = '485-kiosk-immobile',
	'kiosk-food' = '486-kiosk-food',
	exchange = '487-exchange',
	bullets = '488-bullets',
	gun = '489-gun',
	star = '49-star',
	'gun-off' = '490-gun-off',
	'charging-station' = '491-charging-station',
	'gas-station' = '492-gas-station',
	rotate = '493-rotate',
	'rotate-horizontal' = '494-rotate-horizontal',
	'rotate-vertical' = '495-rotate-vertical',
	podcast = '496-podcast',
	more = '497-more',
	'more-vertical' = '498-more-vertical',
	'skull-crossbones' = '499-skull-crossbones',
	settings = '5-settings',
	'star-empty' = '50-star-empty',
	skull = '500-skull',
	server = '501-server',
	'server-plus' = '502-server-plus',
	'server-minus' = '503-server-minus',
	'server-no' = '504-server-no',
	'server-check' = '505-server-check',
	'server-lock' = '506-server-lock',
	'server-refresh' = '507-server-refresh',
	'server-flag' = '508-server-flag',
	'server-cogwheel' = '509-server-cogwheel',
	pulse = '51-pulse',
	'light-beacon' = '510-light-beacon',
	bed = '511-bed',
	'bed-single' = '512-bed-single',
	cot = '513-cot',
	'personal-hygiene' = '514-personal-hygiene',
	hairdresser = '515-hairdresser',
	'bed-sleeping' = '516-bed-sleeping',
	'food-service' = '517-food-service',
	'lamp-table' = '518-lamp-table',
	lamp = '519-lamp',
	eye = '52-eye',
	hourglass = '520-hourglass',
	monitor = '521-monitor',
	monitors = '522-monitors',
	'monitor-rotate' = '523-monitor-rotate',
	'monitor-vertical' = '524-monitor-vertical',
	'phone-to-horizontal' = '525-phone-to-horizontal',
	'phone-rotate' = '526-phone-rotate',
	'phone-horizontal' = '527-phone-horizontal',
	shower = '528-shower',
	'shower-alt' = '529-shower-alt',
	'eye-off' = '53-eye-off',
	bath = '530-bath',
	'user-parents-alt' = '531-user-parents-alt',
	'user-family' = '532-user-family',
	'user-child' = '533-user-child',
	'user-boy' = '534-user-boy',
	'user-girl' = '535-user-girl',
	speakers = '536-speakers',
	progress = '537-progress',
	tasks = '538-tasks',
	barcode = '539-barcode',
	alarm = '54-alarm',
	'qr-code' = '540-qr-code',
	'credit-empty' = '541-credit-empty',
	credit = '542-credit',
	'star-half' = '543-star-half',
	cloud = '544-cloud',
	'cloud-upload' = '545-cloud-upload',
	'cloud-download' = '546-cloud-download',
	'cloud-refresh' = '547-cloud-refresh',
	'cloud-alert' = '548-cloud-alert',
	'cloud-pause' = '549-cloud-pause',
	clock = '55-clock',
	'cloud-check' = '550-cloud-check',
	bag = '551-bag',
	'hand-donate' = '552-hand-donate',
	'hand-heart' = '553-hand-heart',
	handshake = '554-handshake',
	'hand-praying' = '555-hand-praying',
	flash = '556-flash',
	'flash-automatic' = '557-flash-automatic',
	'flash-no' = '558-flash-no',
	target = '559-target',
	stopwatch = '56-stopwatch',
	marriage = '560-marriage',
	shoes = '561-shoes',
	'shoes-off' = '562-shoes-off',
	'card-hearts' = '563-card-hearts',
	'card-spades' = '564-card-spades',
	'card-diamonds' = '565-card-diamonds',
	'card-clubs' = '566-card-clubs',
	'bring-forward' = '567-bring-forward',
	'bring-to-front' = '568-bring-to-front',
	'send-backward' = '569-send-backward',
	'scissors-horizontal' = '57-scissors-horizontal',
	'send-to-back' = '570-send-to-back',
	'washing-machine' = '571-washing-machine',
	dryer = '572-dryer',
	dishwasher = '573-dishwasher',
	oven = '574-oven',
	hob = '575-hob',
	microwave = '576-microwave',
	cluster = '577-cluster',
	share = '578-share',
	'translate-alt' = '579-translate-alt',
	history = '58-history',
	translate = '580-translate',
	directions = '581-directions',
	'directions-arrow' = '582-directions-arrow',
	'finish-line' = '583-finish-line',
	radio = '584-radio',
	start = '585-start',
	bomb = '586-bomb',
	bug = '587-bug',
	'book-open-text' = '588-book-open-text',
	'book-open' = '589-book-open',
	truck = '59-truck',
	newspaper = '590-newspaper',
	'map-marker' = '591-map-marker',
	map = '592-map',
	route = '593-route',
	nearby = '594-nearby',
	'nearby-alt' = '595-nearby-alt',
	'piggy-bank' = '596-piggy-bank',
	'piggy-bank-coins' = '597-piggy-bank-coins',
	'sound-surround' = '598-sound-surround',
	car = '6-car',
	timer = '60-timer',
	'user-no' = '601-user-no',
	'user-lock' = '602-user-lock',
	'user-flag' = '603-user-flag',
	'user-star' = '604-user-star',
	'user-alert' = '605-user-alert',
	'user-chat' = '606-user-chat',
	'user-check' = '607-user-check',
	'square-hospital' = '608-square-hospital',
	'circle-red-cross' = '609-circle-red-cross',
	compass = '61-compass',
	'star-of-life' = '610-star-of-life',
	'copy-duplicate' = '611-copy-duplicate',
	scissors = '612-scissors',
	paste = '613-paste',
	copy = '614-copy',
	'balance-scales' = '615-balance-scales',
	'court-gavel' = '616-court-gavel',
	'court-gavel-alt' = '617-court-gavel-alt',
	'circle-hospital' = '618-circle-hospital',
	'square-red-cross' = '619-square-red-cross',
	presentation = '62-presentation',
	'star-of-life-empty' = '620-star-of-life-empty',
	'scale-personal' = '621-scale-personal',
	'scale-kitchen' = '622-scale-kitchen',
	fireworks = '623-fireworks',
	'fireworks-alt' = '624-fireworks-alt',
	chemistry = '625-chemistry',
	'chemistry-alt' = '626-chemistry-alt',
	'syringe-empty' = '627-syringe-empty',
	syringe = '628-syringe',
	heartbeat = '629-heartbeat',
	paperclip = '63-paperclip',
	'heart-broken' = '630-heart-broken',
	'circle-plus' = '631-circle-plus',
	'circle-minus' = '632-circle-minus',
	'circle-remove' = '633-circle-remove',
	'circle-check' = '634-circle-check',
	'circle-question' = '635-circle-question',
	'circle-info' = '636-circle-info',
	'circle-alert' = '637-circle-alert',
	'triangle-alert' = '638-triangle-alert',
	'octagon-remove-empty' = '639-octagon-remove-empty',
	power = '64-power',
	'octagon-remove' = '640-octagon-remove',
	'triangle-radioactive' = '641-triangle-radioactive',
	radioactive = '642-radioactive',
	compound = '643-compound',
	dna = '644-dna',
	biohazard = '645-biohazard',
	'circle-play' = '646-circle-play',
	'circle-down' = '647-circle-down',
	'circle-up' = '648-circle-up',
	'circle-left' = '649-circle-left',
	lightbulb = '65-lightbulb',
	'circle-right' = '650-circle-right',
	king = '651-king',
	queen = '652-queen',
	rook = '653-rook',
	bishop = '654-bishop',
	knight = '655-knight',
	pawn = '656-pawn',
	door = '657-door',
	bicycle = '658-bicycle',
	id = '659-id',
	tag = '66-tag',
	payment = '660-payment',
	'legal-section-sign' = '661-legal-section-sign',
	voicemail = '662-voicemail',
	'equalizer-dots' = '663-equalizer-dots',
	'equalizer-bars' = '664-equalizer-bars',
	taxi = '665-taxi',
	'transport-mixed' = '666-transport-mixed',
	metro = '667-metro',
	'car-rental' = '668-car-rental',
	tram = '669-tram',
	tags = '67-tags',
	dashboard = '670-dashboard',
	mountains = '671-mountains',
	forest = '672-forest',
	cableway = '673-cableway',
	canister = '674-canister',
	'motor-oil' = '675-motor-oil',
	'car-battery' = '676-car-battery',
	'car-wheel' = '677-car-wheel',
	'car-wheel-defect' = '678-car-wheel-defect',
	'car-wheel-wrench' = '679-car-wheel-wrench',
	education = '68-education',
	'car-wheel-wrench-alt' = '680-car-wheel-wrench-alt',
	'suitcase-doctor' = '681-suitcase-doctor',
	tent = '682-tent',
	'key-rounded' = '683-key-rounded',
	flashlight = '684-flashlight',
	backpack = '685-backpack',
	watch = '686-watch',
	'watch-squared' = '687-watch-squared',
	'smart-bracelet' = '688-smart-bracelet',
	lighter = '689-lighter',
	ruler = '69-ruler',
	'multifunction-knife' = '690-multifunction-knife',
	'text-underline' = '691-text-underline',
	font = '692-font',
	superscript = '693-superscript',
	subscript = '694-subscript',
	'text-background' = '695-text-background',
	header = '696-header',
	'directions-sign' = '697-directions-sign',
	'barbed-wire' = '698-barbed-wire',
	tractor = '699-tractor',
	'user-plus' = '7-user-plus',
	gift = '70-gift',
	fence = '700-fence',
	'ice-cream' = '701-ice-cream',
	'ice-cream-off' = '702-ice-cream-off',
	'remote-control' = '703-remote-control',
	pills = '704-pills',
	medicine = '705-medicine',
	park = '706-park',
	'dog-tags' = '707-dog-tags',
	'luggage-alt' = '708-luggage-alt',
	'lawn-mower' = '709-lawn-mower',
	umbrella = '71-umbrella',
	'brick-wall' = '710-brick-wall',
	'voting-urn' = '711-voting-urn',
	government = '712-government',
	announcement = '713-announcement',
	dustbin = '714-dustbin',
	feather = '715-feather',
	recycling = '716-recycling',
	'home-fire' = '717-home-fire',
	'home-flood' = '718-home-flood',
	water = '719-water',
	book = '72-book',
	'home-for-sale' = '720-home-for-sale',
	campfire = '721-campfire',
	fireplace = '722-fireplace',
	basket = '723-basket',
	'basket-in' = '724-basket-in',
	'basket-out' = '725-basket-out',
	'basket-checkout' = '726-basket-checkout',
	'basket-check' = '727-basket-check',
	firefighters = '728-firefighters',
	police = '729-police',
	bookmark = '73-bookmark',
	ambulance = '730-ambulance',
	ear = '731-ear',
	'ear-off' = '732-ear-off',
	'theater-masks' = '733-theater-masks',
	kettlebell = '734-kettlebell',
	ticket = '735-ticket',
	'ticket-parking' = '736-ticket-parking',
	'parking-meter' = '737-parking-meter',
	parking = '738-parking',
	check = '739-check',
	wifi = '74-wifi',
	hash = '740-hash',
	'align-top' = '741-align-top',
	'align-bottom' = '742-align-bottom',
	'align-horizontal' = '743-align-horizontal',
	'align-left' = '744-align-left',
	'align-vertical' = '745-align-vertical',
	'align-right' = '746-align-right',
	'reflect-y' = '747-reflect-y',
	'reflect-x' = '748-reflect-x',
	'resize-horizontal' = '749-resize-horizontal',
	cup = '75-cup',
	'resize-vertical' = '750-resize-vertical',
	'call-redirect' = '751-call-redirect',
	'call-ip' = '752-call-ip',
	'call-record' = '753-call-record',
	'call-music' = '754-call-music',
	'call-data' = '755-call-data',
	'call-pause' = '756-call-pause',
	'call-incoming-alt' = '757-call-incoming',
	'call-outgoing-alt' = '758-call-outgoing',
	'call-video' = '759-call-video',
	stroller = '76-stroller',
	'call-lock' = '760-call-lock',
	sync = '761-sync',
	'sync-alert' = '762-sync-alert',
	'sync-check' = '763-sync-check',
	'modal-window' = '764-modal-window',
	gas = '765-gas',
	'waste-pipe' = '766-waste-pipe',
	'waste-pipe-end' = '767-waste-pipe-end',
	toilet = '768-toilet',
	'drinking-water' = '769-drinking-water',
	headphones = '77-headphones',
	'drinking-water-off' = '770-drinking-water-off',
	apple = '771-apple',
	neighborhood = '772-neighborhood',
	temperature = '773-temperature',
	'temperature-alert' = '774-temperature-alert',
	'temperature-set' = '775-temperature-set',
	'temperature-low' = '776-temperature-low',
	'temperature-high' = '777-temperature-high',
	tornado = '778-tornado',
	'ice-lolly' = '779-ice-lolly',
	headset = '78-headset',
	'ice-lolly-eaten' = '780-ice-lolly-eaten',
	milk = '781-milk',
	egg = '782-egg',
	wheat = '783-wheat',
	corn = '784-corn',
	soya = '785-soya',
	nuts = '786-nuts',
	carrot = '787-carrot',
	meat = '788-meat',
	seafood = '789-seafood',
	'triangle-empty-alert' = '79-triangle-empty-alert',
	fish = '790-fish',
	'square-email' = '791-square-email',
	email = '792-email',
	paired = '793-paired',
	'paired-off' = '794-paired-off',
	set = '795-set',
	'set-down' = '796-set-down',
	'chevron-last-down' = '797-chevron-last-down',
	'chevron-last-up' = '798-chevron-last-up',
	'chevron-last-left' = '799-chevron-last-left',
	'user-minus' = '8-user-minus',
	bars = '80-bars',
	'chevron-last-right' = '800-chevron-last-right',
	'file-plus' = '801-file-plus',
	'file-minus' = '802-file-minus',
	'file-refresh' = '803-file-refresh',
	'file-lock' = '804-file-lock',
	'file-cloud' = '805-file-cloud',
	'user-rounded' = '806-user-rounded',
	'user-squared' = '807-user-squared',
	'drop-down' = '808-drop-down',
	'drop-plus' = '809-drop-plus',
	retweet = '81-retweet',
	'block-move' = '810-block-move',
	'fingerprint-scan' = '811-fingerprint-scan',
	fingerprint = '812-fingerprint',
	'fingerprint-lock' = '813-fingerprint-lock',
	'fingerprint-check' = '814-fingerprint-check',
	'fingerprint-remove' = '815-fingerprint-remove',
	satellite = '816-satellite',
	'satellite-dish' = '817-satellite-dish',
	'satellite-dish-alt' = '818-satellite-dish-alt',
	robot = '819-robot',
	refresh = '82-refresh',
	radar = '820-radar',
	'battery-charging' = '821-battery-charging',
	'battery-charged' = '822-battery-charged',
	'battery-three-quarters' = '823-battery-three-quarters',
	'battery-half' = '824-battery-half',
	'battery-quarter' = '825-battery-quarter',
	'battery-low' = '826-battery-low',
	'arrow-thin-down' = '827-arrow-thin-down',
	'arrow-thin-up' = '828-arrow-thin-up',
	'arrow-thin-left' = '829-arrow-thin-left',
	roundabout = '83-roundabout',
	'arrow-thin-right' = '830-arrow-thin-right',
	male = '831-male',
	female = '832-female',
	'virgin-female' = '833-virgin-female',
	intersex = '834-intersex',
	transgender = '835-transgender',
	lesbian = '836-lesbian',
	gay = '837-gay',
	hetero = '838-hetero',
	other = '839-other',
	random = '84-random',
	unknown = '840-unknown',
	'square-plus' = '841-square-plus',
	'square-minus' = '842-square-minus',
	'square-remove' = '843-square-remove',
	'square-check' = '844-square-check',
	'square-question' = '845-square-question',
	'square-info' = '846-square-info',
	'square-alert' = '847-square-alert',
	subtitles = '848-subtitles',
	'computer-network' = '849-computer-network',
	heating = '85-heating',
	'computer-network-alt' = '850-computer-network-alt',
	'subtitles-off' = '851-subtitles-off',
	'subtitles-plus' = '852-subtitles-plus',
	'subtitles-minus' = '853-subtitles-minus',
	'audio-description-d' = '854-audio-description-d',
	'audio-description' = '855-audio-description',
	'square-play' = '856-square-play',
	'square-down' = '857-square-down',
	'square-up' = '858-square-up',
	'square-left' = '859-square-left',
	reload = '86-reload',
	'square-right' = '860-square-right',
	'vr-inside' = '861-vr-inside',
	vr = '862-vr',
	'user-vr' = '863-user-vr',
	'user-vr-plus' = '864-user-vr-plus',
	'user-vr-minus' = '865-user-vr-minus',
	'view-full' = '866-view-full',
	'view-half' = '867-view-half',
	puzzle = '868-puzzle',
	'door-open' = '869-door-open',
	tv = '87-tv',
	'door-close' = '870-door-close',
	package = '871-package',
	'one-day-delivery' = '872-one-day-delivery',
	forklift = '873-forklift',
	'transport-trolley' = '874-transport-trolley',
	'simple-trolley' = '875-simple-trolley',
	'palette-package' = '876-palette-package',
	warehouse = '877-warehouse',
	'this-side-up' = '878-this-side-up',
	'terminal-empty' = '879-terminal-empty',
	'book-log' = '88-book-log',
	terminal = '880-terminal',
	candle = '881-candle',
	balloon = '882-balloon',
	balloons = '883-balloons',
	missile = '884-missile',
	'step-back' = '885-step-back',
	'step-forward' = '886-step-forward',
	undo = '887-undo',
	redo = '888-redo',
	'three-dimensional' = '889-three-dimensional',
	'book-address' = '89-book-address',
	'three-dimensional-full' = '890-three-dimensional-full',
	factory = '891-factory',
	'factory-alt' = '892-factory-alt',
	'user-worker' = '893-user-worker',
	barrel = '894-barrel',
	'dice-one' = '895-dice-one',
	'dice-two' = '896-dice-two',
	'dice-three' = '897-dice-three',
	'dice-four' = '898-dice-four',
	'dice-five' = '899-dice-five',
	film = '9-film',
	building = '90-building',
	'dice-six' = '900-dice-six',
	'slightly-smiling' = '901-slightly-smiling',
	'slightly-frowning' = '902-slightly-frowning',
	pool = '903-pool',
	tennis = '904-tennis',
	badminton = '905-badminton',
	restart = '906-restart',
	replay = '907-replay',
	honeycombs = '908-honeycombs',
	honeybee = '909-honeybee',
	eyedropper = '91-eyedropper',
	honey = '910-honey',
	fan = '911-fan',
	wind = '912-wind',
	rechargeable = '913-rechargeable',
	'mobile-phone-lock' = '914-mobile-phone-lock',
	'mobile-phone-check' = '915-mobile-phone-check',
	'mobile-phone-cogwheel' = '916-mobile-phone-cogwheel',
	'mobile-phone-alert' = '917-mobile-phone-alert',
	'power-plant-wind' = '918-power-plant-wind',
	'power-plant-solar' = '919-power-plant-solar',
	contrast = '92-contrast',
	'power-plant-water' = '920-power-plant-water',
	'rewind-five' = '921-rewind-five',
	'rewind-ten' = '922-rewind-ten',
	'rewind-fifteen' = '923-rewind-fifteen',
	'rewind-thirty' = '924-rewind-thirty',
	'forward-five' = '925-forward-five',
	'forward-ten' = '926-forward-ten',
	'forward-fifteen' = '927-forward-fifteen',
	'forward-thirty' = '928-forward-thirty',
	passport = '929-passport',
	drop = '93-drop',
	'passport-alt' = '930-passport-alt',
	'speech-bubble-question' = '931-speech-bubble-question',
	'speech-bubble-info' = '932-speech-bubble-info',
	'speech-bubble-alert' = '933-speech-bubble-alert',
	'reload-alt' = '934-reload-alt',
	'power-cord-plug' = '935-power-cord-plug',
	'power-cord-plug-off' = '936-power-cord-plug-off',
	'wireless-charging' = '937-wireless-charging',
	'tv-streaming' = '938-tv-streaming',
	cheque = '939-cheque',
	crop = '94-crop',
	'cheque-off' = '940-cheque-off',
	'buildings-mixed' = '941-buildings-mixed',
	'buildings-city' = '942-buildings-city',
	'buildings-park' = '943-buildings-park',
	highway = '944-highway',
	'traffic-lights' = '945-traffic-lights',
	'traffic-lights-off' = '946-traffic-lights-off',
	'circle-more' = '947-circle-more',
	'square-more' = '948-square-more',
	'circle-menu' = '949-circle-menu',
	'vector-path' = '95-vector-path',
	'square-menu' = '950-square-menu',
	'list-letters' = '951-list-letters',
	'list-numbers' = '952-list-numbers',
	'initial-letter' = '953-initial-letter',
	brain = '954-brain',
	'brain-ai' = '955-brain-ai',
	'artificial-intelligence' = '956-artificial-intelligence',
	microchip = '957-microchip',
	'filter-off' = '958-filter-off',
	'book-library-search' = '959-book-library-search',
	'vector-path-circle' = '96-vector-path-circle',
	'files-queue' = '960-files-queue',
	'cloud-off' = '961-cloud-off',
	trending = '962-trending',
	disappearing = '963-disappearing',
	layers = '964-layers',
	'layers-plus' = '965-layers-plus',
	'layers-minus' = '966-layers-minus',
	'layers-lock' = '967-layers-lock',
	'layers-down' = '968-layers-down',
	'layers-up' = '969-layers-up',
	'vector-path-pentagon' = '97-vector-path-pentagon',
	'layers-cogwheel' = '970-layers-cogwheel',
	'axes-three-dimensional' = '971-axes-three-dimensional',
	'axes-two-dimensional' = '972-axes-two-dimensional',
	rulers = '973-rulers',
	'spell-check' = '974-spell-check',
	'spell-check-check' = '975-spell-check-check',
	'globe-data' = '976-globe-data',
	'map-satellite' = '977-map-satellite',
	'map-cadastral' = '978-map-cadastral',
	'map-aerial' = '979-map-aerial',
	'vector-path-line' = '98-vector-path-line',
	'map-tourist' = '980-map-tourist',
	cookie = '981-cookie',
	'cookie-alt' = '982-cookie-alt',
	cookies = '983-cookies',
	'cash-register' = '984-cash-register',
	'cash-register-alt' = '985-cash-register-alt',
	'hard-drive-no' = '986-hard-drive-no',
	'switch-off' = '987-switch-off',
	'switch-on' = '988-switch-on',
	receipt = '989-receipt',
	'vector-path-curve' = '99-vector-path-curve',
	invoice = '990-invoice',
	'usb-device' = '991-usb-device',
	'usb-device-lock' = '992-usb-device-lock',
	'usb-device-no' = '993-usb-device-no',
	'usb-device-cogwheel' = '994-usb-device-cogwheel',
	'usb-device-eject' = '995-usb-device-eject',
	'memory-card' = '996-memory-card',
	'memory-card-lock' = '997-memory-card-lock',
	'memory-card-no' = '998-memory-card-no',
	'memory-card-cogwheel' = '999-memory-card-cogwheel',
	blank = 'blank',
	'call-dialing' = 'call-dialing',
	'call-idle' = 'call-idle',
	'call-incoming' = 'call-incoming',
	'call-outgoing' = 'call-outgoing',
	'call-ringing' = 'call-ringing'
}
